export const UserEndpoint = {
  RETRIEVE_NAVIGATION_ITEMS: '/api/admin/user/navigation',
  CHANGE_PASSWORD: '/api/admin/user/changePassword',
};
